var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat-1_svg__Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 393.4 219.79",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".chat-1_svg__st5{fill:#fff}.chat-1_svg__st6{fill:#664f26}.chat-1_svg__st7{fill:#231f20}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.48 88.82V21.34c0-9.73 7.88-17.61 17.61-17.61h265.45c9.73-.01 17.61 7.87 17.62 17.6v173.29c.03 9.73-7.84 17.64-17.57 17.67h-265.5c-9.75-.02-17.63-7.94-17.61-17.69V131.18l-78-17.42 78-24.94z",
    fill: "#fff",
    stroke: "#66b0f0",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.48 88.82V21.34c0-9.73 7.88-17.61 17.61-17.61h265.45c9.73-.01 17.61 7.87 17.62 17.6v173.29c.03 9.73-7.84 17.64-17.57 17.67h-265.5c-9.75-.02-17.63-7.94-17.61-17.69V131.18l-78-17.42 78-24.94z",
    fill: "none",
    stroke: "#ff0001",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.39 128.19s7.71-13.82 7.71-34.27c0-26.91-19.88-58.73-71-58.73s-71 31.82-71 58.73c0 20.45 7.7 34.27 7.7 34.27-8.75 10.13-14.1 30.28-6.55 43.63 3.06 5.42 34.43 24.4 37.52-9.44h64.6c3.08 33.84 34.45 14.86 37.51 9.44 7.55-13.35 2.2-33.5-6.55-43.63",
    fill: "#ffb200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.15 44.98c-37.43 0-64.88 19.58-64.88 44.05 0 0 10-36.71 64.88-36.71s62.38 36.71 62.38 36.71c0-24.47-25-44.05-62.38-44.05",
    fill: "#c28ff0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.13 133.08c15.22 0 15.22-22 0-22v-7.35S212.49 101.49 193 71.92c4.9 29.78-18.88 39.16-18.88 39.16-15.21 0-15.21 22 0 22 0 17.13 18 44 62 44s62-26.92 62-44",
    fill: "#ffde66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "chat-1_svg__st5",
    d: "M266.72 103.71c8.79 0 15.91 7.12 15.91 15.91s-7.12 15.91-15.91 15.91-15.91-7.12-15.91-15.91 7.12-15.91 15.91-15.91M205.54 103.71c8.79.01 15.91 7.13 15.9 15.92-.01 8.79-7.13 15.91-15.92 15.9-8.78-.01-15.9-7.13-15.9-15.91 0-8.79 7.12-15.91 15.92-15.91"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "chat-1_svg__st6",
    d: "M266.72 108.61c6.08 0 11 4.92 11 11s-4.92 11-11 11-11-4.92-11-11 4.93-11 11-11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "chat-1_svg__st7",
    d: "M266.72 115.95c2.03 0 3.67 1.64 3.67 3.67s-1.64 3.67-3.67 3.67-3.67-1.64-3.67-3.67a3.679 3.679 0 013.67-3.67"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "chat-1_svg__st6",
    d: "M205.54 108.61c6.08 0 11 4.92 11 11s-4.92 11-11 11-11-4.92-11-11 4.93-11 11-11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "chat-1_svg__st7",
    d: "M205.54 115.95c2.03.01 3.67 1.65 3.66 3.68a3.666 3.666 0 01-3.68 3.66 3.677 3.677 0 01-3.66-3.67 3.681 3.681 0 013.68-3.67"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M255.92 162.14c-12.76-8.82-26.91-8.76-39.59 0-1.53 1-2.9-.77-1.87-2.47 7.59-11.97 23.45-15.51 35.42-7.91 3.19 2.02 5.89 4.73 7.91 7.91 1 1.7-.34 3.52-1.87 2.47",
    fill: "#947338"
  })));
}
export default __webpack_public_path__ + "6bfc858e21baebc59411cb732b7828cc.svg";
export { SvgChat1 as ReactComponent };